import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      trainTemplateData: '',
      npiGroups: '',
      revisionVersionSelected: null,
      id: this.$route.params.id,
      update_revision_id_status: '',
      esm_status: '',
      sv_status: '',
      cv_status: '',
      status_array: [],
      updatedNoOfMappings: null
    }
  },
  computed: {
    ...mapGetters(['idToken']),
    trainTemplate () {
      return this.trainTemplateData
    },
    isLatestVersion () {
      return this.revisionVersionSelected === this.trainTemplateData.revision_ids[0]
    }
  },
  watch: {
    trainTemplateData: {
      handler: function () {
        this.init()
      },
      deep: true
    },
    '$route': function () {
      this.id = this.$route.params.id
      this.fetchTemplateWithOutGaurd()
    }
  },
  mounted () {
    // Toggle sidebar for this page
    // TODO: Move to a common place. Remove duplicates
    let classList = document.body.classList
    if (!classList.contains('sidebar-minimized')) {
      classList.toggle('sidebar-minimized')
      classList.toggle('brand-minimized')
    }
    this.fetchTemplateWithOutGaurd()
  },
  methods: {
    // TODO: Add route guard and refactor the path and other reset options.
    fetchTemplateWithOutGaurd (version) {
      this.editorDataLoaded = false
      this.mappingDataLoaded = false
      let editorClass = this.$refs.canvasEditor.classList
      var url = version ? 'templates/' + this.id + '?version=' + version : 'templates/' + this.id
      if (!editorClass.contains('hidden-cn')) { editorClass.toggle('hidden-cn') }
      Vue.axios.get(url, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.status_array = []
          this.trainTemplateData = res.data.template
          this.updatedNoOfMappings = res.data.template.no_of_template_mappings
          this.update_revision_id_status = res.data.template.update_revision_id_status
          this.esm_status = res.data.template.esm_status
          this.sv_status = res.data.template.sv_status
          this.cv_status = res.data.template.cv_status
          this.npiGroups = res.data.template.npi_group
          this.allPageIdMap = res.data.template.all_template_ids
          this.revisionVersionSelected = res.data.template.current_revision_id
          this.draw = this.revisionVersionSelected === this.trainTemplateData.revision_ids[0] || !this.trainTemplateData.revision_ids.length
          // TODO: Refactor this reset in to seperate mixin.
          this.pathCount = 1
          this.setPagination('templates')
          this.resetEditHistory()
          this.mappingDataLoaded = true
          if (this.esm_status) {
            this.status_array.push(this.$t('TEMPLATE.ESM_CLONING'))
          }
          if (this.sv_status) {
            this.status_array.push(this.$t('TEMPLATE.SV_CLONING'))
          }
          if (this.cv_status) {
            this.status_array.push(this.$t('TEMPLATE.CV_CLONING'))
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show('Session expired, please login to continue', { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show('Something went wrong. Please retry', { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/fetchTemplate.js